// Las teclas del chat abierto: Esc lo cierra (si no estás escribiendo) y Ctrl+I / ⌘I abre y cierra la información (el
// panel derecho), también escribiendo (04-11, ficha.md §3).
//
// 05-11 (auditoría, QA M3/M4): Esc va por la pila de Escape de la oficina (ui/useEscape.ts) — el chat está por encima de
// «Ordenar» y por debajo de cualquier hoja (Ctrl+K, la vista previa, una ventana), así que un Escape cierra solo lo de
// arriba. Alt+↓/↑ («siguiente que te necesita») ya no vive aquí: es UN atajo de toda la oficina (marco/useSiguiente.ts),
// también sin chat abierto.
import { useEffect } from 'react';
import { useOficinaStore } from '../store';
import { escribiendoConTexto, hayDialogoAbierto, NIVEL_ESCAPE, useEscape } from '../ui/useEscape';

export function useTeclasChat({ alCerrar, alAlternarInfo }: { alCerrar: () => void; alAlternarInfo?: () => void }): void {
  // Con texto en la caja (o en el campo que tenga el foco), Esc no cierra nada: el borrador se queda y el chat también.
  useEscape(true, (e) => (escribiendoConTexto(e) ? false : alCerrar()), { clase: 'panel', nivel: NIVEL_ESCAPE.ventana });
  useEffect(() => {
    if (!alAlternarInfo) return;
    const alTeclear = (e: KeyboardEvent) => {
      // Con una ventana (contratar, plan, cerrar) o un menú encima, sus teclas son suyas.
      if (useOficinaStore.getState().contratarAbierto || hayDialogoAbierto()) return;
      if ((e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && e.key.toLowerCase() === 'i') {
        e.preventDefault();
        alAlternarInfo();
      }
    };
    window.addEventListener('keydown', alTeclear);
    return () => window.removeEventListener('keydown', alTeclear);
  }, [alAlternarInfo]);
}
